import { render, staticRenderFns } from "./AddCompany.vue?vue&type=template&id=12b2e5cd&scoped=true"
import script from "./AddCompany.vue?vue&type=script&lang=js"
export * from "./AddCompany.vue?vue&type=script&lang=js"
import style0 from "./AddCompany.vue?vue&type=style&index=0&id=12b2e5cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b2e5cd",
  null
  
)

export default component.exports